// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sC8h_TIutWsbteV2ruVo{fill:var(--moveo-text-02)}.MimkB4NMw69mhMIsg_k1{fill:var(--moveo-text-success)}.TZ5W7vCPqIQREEoozyit{fill:var(--moveo-text-failure)}", "",{"version":3,"sources":["webpack://./src/components/Icons/StatusDotIcon.module.scss"],"names":[],"mappings":"AAEA,sBACE,yBAAA,CAGF,sBACE,8BAAA,CAGF,sBACE,8BAAA","sourcesContent":["@use '../../styles/theme' as *;\n\n.icon {\n  fill: var($text-02);\n}\n\n.online {\n  fill: var($text-success);\n}\n\n.offline {\n  fill: var($text-failure);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "sC8h_TIutWsbteV2ruVo",
	"online": "MimkB4NMw69mhMIsg_k1",
	"offline": "TZ5W7vCPqIQREEoozyit"
};
export default ___CSS_LOADER_EXPORT___;
